/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import Vue from 'vue'
import { createStore } from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

// Vue.use(Vuex)

export const store = createStore({
  getters,
  mutations,
  state () {
    return state
  },
  actions,
  strict: process.env.NODE_ENV !== 'production'
})
